export type ConsumerData = Record<string, unknown>;

export declare type Approval = 'Dormant' | 'Edit' | 'Pending' | 'Live';

export const fonts = [
  {
    id: 'def',
    name: 'Standardschrift'
  },
  {
    id: 'abu',
    name: 'ABU'
  },
  {
    id: 'gru',
    name: 'Grusi'
  },
  {
    id: 'gruAT',
    name: 'GrusiAT'
  },
  {
    id: 'pes',
    name: 'Pesendorfer'
  },
];

// Default theme from Player file 'theme.mock.ts'
export const defaultTheme = {
  primaryColor: '#009EA6',
  secondaryColor: '#00dbca',
  tertiaryColor: '#ffffff',
  placeholderColor: '#f2f2f2',
  hoverColor: '#00dbca',
  drawColor: '#009EA6',
  drawHighlightColor: '#00dbca',
  compareSolutionsBgColor: '#00dbca',
  useAudioIcon: false,
  useAudioIconTts: false,
  useAudioIconHelp: false,
  hideCopyrightInfoButton: false,
  forceSmallFooter: false,
  showSequenceGroupFinishedBtn: false,
  lightDialogs: true,
  hideShareCheckbox: false,
  hideSequenceTitle: false,
  isKapReview: false,
};

// Posible types of competencies
export declare type Competence =
  'KapiertCompetence' |
  'ODSekCompetence' |
  'ODGSCompetence' |
  'BiboxCompetence' |
  'PPCompetence' |
  'AbiGuideCompetence';

export declare type LearnObjectType = 'exercise' | 'exam' | 'explanation' | 'learnSequence' | 'examSequence' | 'sequenceGroup';

export declare type MediaType = 'Animation' | 'Audio' | 'Film' | 'Html' | 'Image' | 'Pdf' | 'Video' | undefined;

export const metadataTypeMap = [
  'String',
  'Int',
  'Float',
  'DropDown',
  'CheckBox',
  'Selection',
  'SingleSelection',
  'UnsignedIntStepper',
  'LearnItemMetaField',
  'KapiertCompetence',
  'BiboxCompetence',
  'ODSekCompetence',
  'ODGSCompetence',
  'PPCompetence',
  'AbiGuideCompetence',
  'FunctionalHelp',
  'ReadOut',
  'ValueFromApiResult',
  'MediaList',
  'IconSelection',
  'Competence',
  'ColorPicker',
  'PairedSelection'
] as const;

export type MetadataFieldDataType = typeof metadataTypeMap[number];

/** needed, so you can use the types in @() syntax in view */
export const MetadataFieldDataTypes: Record<MetadataFieldDataType, MetadataFieldDataType> =
  metadataTypeMap.reduce((acc, key) => {
    acc[key] = key;
    return acc;
  }, {} as Record<MetadataFieldDataType, MetadataFieldDataType>);

export const ExerciseKindMap = {
  AUSWAHL: 'auswahl',
  AUSWAHL_TEXT: 'auswahl.auswahlText',
  AUSWAHL_BILD: 'auswahl.auswahlBild',
  BUCHUNGSTRAINER: 'buchungstrainer',
  WORTWAHL_MARKIERTEXT: 'wortwahl-markiertext',
  FARBWAHL_MARKIERTEXT: 'farbwahl-markiertext',
  WECHSELTEXT: 'wechseltext',
  WECHSELTEXT_GROSSKLEIN: 'wechseltext-grossklein',
  WECHSELTEXT_BILD: 'wechseltext-bild',
  WECHSELBILD: 'wechselbild',
  ZEICHENSETZUNG: 'zeichensetzung',
  ZUORDNUNG_NACH_KATEGORIE: 'zuordnung-nach-kategorie',
  ZUORDNUNG_NACH_KATEGORIE_AUS_TEXT: 'zuordnung-nach-kategorie-aus-text',
  LUECKENBILD: 'lueckenbild',
  LUECKENTEXT: 'lueckentext',
  LUECKENTABELLE: 'lueckentabelle',
  FREITEXT: 'freitext',
  SATZGLIEDER_UMSTELLEN: 'satzglieder-umstellen',
  ZUORDNUNG_TEXT_DND: 'zuordnung-text-dnd',
  ZUORDNUNG_BILD_DND_TEXT_TO_BILD: 'zuordnung-bild-dnd.zuordnungTextToBildDnd',
  ZUORDNUNG_BILD_DND_BILD_TO_BILD: 'zuordnung-bild-dnd.zuordnungBildToBildDnd',
  REIHENFOLGE_BESTIMMEN_TEXT: 'reihenfolge-bestimmen.reihenfolgeText',
  REIHENFOLGE_BESTIMMEN_BILD: 'reihenfolge-bestimmen.reihenfolgeBild',
  MATHEAUFGABE: 'matheaufgabe',
  WINKEL_MESSEN: 'winkel-messen',
  WINKEL_ZEICHNEN: 'winkel-zeichnen',
  MM_PAPIER: 'mm-papier',
  LSA_ZUSAMMENFASSUNG: 'lsa-zusammenfassung',
  LSA_FRAGE_ZUM_TEXT: 'lsa-frage-zum-text',
  TASCHENRECHNER: 'taschenrechner',
  SILBENBOEGEN: 'silbenboegen',
  MENGEN_LEGEN: 'mengen-legen',
  NONE: 'none'
} as const;

export type ExerciseKind = (typeof ExerciseKindMap)[keyof typeof ExerciseKindMap];

export function getExerciseKinds(): ExerciseKind[] {
  return Object.values(ExerciseKindMap) as ExerciseKind[];
}
